import { useEffect, useState } from "react";
import { useGlobalContext } from "src/context/useGlobalContext";
import ContactMeModal from "../contactMeModal/ContactMeModal";
import HeroBanner from "../heroBanner/HeroBanner";
import JuiceRaw from "../juiceRaw/JuiceRaw";
import Experience from "../experience/Experience";
import Skills from "../skills/Skills";
import ContactMe from "../contactMe/ContactMe";
import NavigateToShopifyModal from "../navigateToShopifyModal/NavigateToShopifyModal";
import LazyLoadComponent from "../lazyLoadComponent/LazyLoadComponent";
import toothSVG from '../../images/tooth.svg';

const Home = ({ ANIMATION_TRANSITION_DELAY }) => {
	const WELCOME_TEXT_ANIMATION_DURATION = 500;
	const ANIMATION_TRANSITION_DURATION = 500;

	const { navigate, documentLoaded_ref } = useGlobalContext();

	const [hideWelcomeMessage, SetHideWelcomeMessage] = useState(
		documentLoaded_ref.current
	);
	const [removeWelcomeMessage, SetRemoveWelcomeMessage] = useState(
		documentLoaded_ref.current
	);	

	useEffect(() => {

        clearParams();

        function clearParams () {
            const path = location.pathname;
            const params = new URLSearchParams(location.search);
            
            params.forEach((_, key) => {
                if(key === 'active-page') return;
                params.delete(key);
            });
            navigate(`${path}?${params.toString()}`, { replace: true });
        }

		if(!documentLoaded_ref.current) {
			setTimeout(() => {
				SetHideWelcomeMessage(true);
			}, ANIMATION_TRANSITION_DELAY);
			setTimeout(() => {
				SetRemoveWelcomeMessage(true);
			}, ANIMATION_TRANSITION_DELAY + WELCOME_TEXT_ANIMATION_DURATION);
		}

		// if(!componentHasRendered_ref.current) {
		// 	componentHasRendered_ref.current = true;
		// 	return
		// };

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add("show");
				} else {
					entry.target.classList.remove("show");
				}
			}, {
                root: null, // default is viewport
                rootMargin: '0px 0px -100px 0px', // top, right, bottom, left
                threshold: 0, // trigger as soon as it enters the margin area
              });
		});

		// document.querySelector('body').style.overflowY = 'hidden';

		setTimeout(() => {
			const textElements = document.querySelectorAll(".text-animate");
			const imageElements = document.querySelectorAll(".image-zoom");
			
			textElements.forEach((element) => observer.observe(element));
			imageElements.forEach((element) => observer.observe(element));
		},  ANIMATION_TRANSITION_DELAY + ANIMATION_TRANSITION_DURATION);

		return () => {
			// document.querySelector('body').style.overflowY = '';
		}

		// --eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<div
				className={`welcome-text flex fixed w-screen h-screen left-0 top-0 justify-center items-center z-10 text-4xl ${
					removeWelcomeMessage ? "hidden" : ""
				} ${hideWelcomeMessage ? "hide" : ""}`}
			>Welcome</div>

            <HeroBanner />

            <LazyLoadComponent spinner={<img src={toothSVG} alt="" />} componentName='Odontogram' height="1013px"/>
			
            <JuiceRaw />
        
            <Experience />

            <Skills />
            
            <ContactMe />

            <ContactMeModal />

            <NavigateToShopifyModal />
		</>
	);
};

export default Home;
